import React, { CSSProperties, useEffect, useRef } from 'react';
import gsap from 'gsap';

type FadeOverlayProps = {
  /** Fires once the fade-in completes. Caller can use this to know the overlay is fully visible. */
  onVisible?: () => void;
};

/**
 * Lightweight full-screen dark overlay with a quick fade-in.
 * Used during in-session navigation (lobby ↔ table) instead of the full
 * SplashScreen so the player doesn't see the cold-start branding mid-session.
 */
const FadeOverlay = ({ onVisible }: FadeOverlayProps) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!ref.current) return;
    gsap.fromTo(
      ref.current,
      { opacity: 0 },
      { opacity: 1, duration: 0.25, ease: 'power2.out', onComplete: onVisible }
    );
  }, []);

  return <div ref={ref} style={overlayStyle} />;
};

export default FadeOverlay;

const overlayStyle: CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100vh',
  background: '#12100c',
  zIndex: 1000,
  opacity: 0
};
